import { Navigate } from "react-router-dom";
import { useUser } from "../context/UserContext";
import Logo from "../assets/images/preload.png";

const RequireSuperuser = ({ children }) => {
  const { userData, error } = useUser();

  if (!userData && !error) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "50vh" }}>
        <h1>
          Cargando
          <p>
            <svg id="page-preload" viewBox="25 25 50 50">
              <circle r="20" cy="50" cx="50"></circle>
            </svg>
          </p>
        </h1>
      </div>
    );
  }

  if (!userData || !userData.es_superusuario) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default RequireSuperuser;
